import { NormalizedPowerRow, PowerMetrics, PowerRecord } from "../types/power";

const toNumber = (value: unknown): number | null => {
  if (value === null || value === undefined || value === "") {
    return null;
  }

  const num = typeof value === "number" ? value : Number(value);
  return Number.isFinite(num) ? num : null;
};

const parseMetrics = (input: unknown): Partial<PowerMetrics> => {
  if (!input) {
    return {};
  }

  if (typeof input === "string") {
    try {
      const parsed = JSON.parse(input);
      if (parsed && typeof parsed === "object") {
        return parsed as Partial<PowerMetrics>;
      }
    } catch (error) {
      return {};
    }
  }

  if (typeof input === "object") {
    return input as Partial<PowerMetrics>;
  }

  return {};
};

export const normalizePowerRecord = (
  record: PowerRecord,
  index: number,
): NormalizedPowerRow => {
  const metrics = parseMetrics(record.data);
  const merged = { ...metrics, ...record };
  const createdAt = record.created_at || new Date().toISOString();
  const id = record.id ?? `${record.name ?? "room"}-${createdAt}-${index}`;

  return {
    id,
    name: record.name || `Room ${index + 1}`,
    model: record.model || "Unknown",
    created_at: createdAt,
    voltage: toNumber(merged.voltage),
    current: toNumber(merged.current),
    power_active: toNumber(merged.power_active),
    export_energy_active: toNumber(merged.export_energy_active),
    total_energy_active: toNumber(merged.total_energy_active),
  };
};

export const normalizePowerRecords = (
  records: PowerRecord[],
): NormalizedPowerRow[] => (records ?? []).map(normalizePowerRecord);
